import { createContext, useContext } from "react";
import { User, Session } from "@supabase/supabase-js";

export interface Profile {
  id: string;
  user_id: string;
  user_type: "humano" | "compawdre" | null;
  email: string;
  full_name: string;
  phone: string | null;
  avatar_url: string | null;
  address_street: string | null;
  address_city: string | null;
  bio: string | null;
  date_of_birth: string | null;
  account_status?: string;
}

export interface SignUpData {
  fullName: string;
  phone?: string;
  userType?: "humano" | "compawdre";
  addressStreet?: string;
  addressCity?: string;
  dateOfBirth?: string;
  sex?: string;
}

export interface AuthContextType {
  user: User | null;
  session: Session | null;
  profile: Profile | null;
  isAdmin: boolean;
  isSignedIn: boolean;
  loading: boolean;
  accountStatus: string;
  emailConfirmed: boolean;
  mustResetPassword: boolean;
  signUp: (email: string, password: string, userData: SignUpData) => Promise<{ error: Error | null }>;
  signIn: (email: string, password: string) => Promise<{ error: Error | null }>;
  signInWithOAuth: (provider: "google" | "apple") => Promise<{ error: Error | null }>;
  signOut: () => Promise<void>;
  refreshProfile: () => Promise<void>;
  clearMustResetPassword: () => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
